const STORAGE_PREFIX = 'avia_aircraft_id';
const CHANGE_EVENT = 'aircraft-changed';

const envDefault = Number(process.env.REACT_APP_AIRCRAFT_ID || 0);

let currentClubId = 0;

function storageKey(clubId: number = currentClubId): string {
  return clubId > 0 ? `${STORAGE_PREFIX}:${clubId}` : STORAGE_PREFIX;
}

function readStoredId(): number {
  try {
    const raw = localStorage.getItem(storageKey());
    if (raw != null && raw !== '') {
      const id = Number(raw);
      if (Number.isFinite(id) && id > 0) return id;
      if (Number.isFinite(id) && id === 0) return 0;
    }
  } catch {
    // ignore
  }
  return envDefault > 0 ? envDefault : 0;
}

let currentAircraftId = readStoredId();

export const getCurrentAircraftId = () => currentAircraftId;

export function setActiveClubId(clubId: number) {
  currentClubId = Number.isFinite(clubId) && clubId > 0 ? clubId : 0;
  currentAircraftId = readStoredId();
}

/** id > 0 — выбрать борт; 0 — сбросить (смена клуба / пустой флот). */
export const setCurrentAircraftId = (id: number) => {
  if (!Number.isFinite(id)) return;
  const next = id > 0 ? id : 0;
  currentAircraftId = next;
  try {
    localStorage.setItem(storageKey(), String(next));
  } catch {
    // ignore
  }
  window.dispatchEvent(
    new CustomEvent(CHANGE_EVENT, { detail: { aircraftId: next } })
  );
};

/**
 * Если сохранённый id нет в списке клуба — взять первый борт.
 * Возвращает актуальный id (0, если бортов нет).
 */
export function syncAircraftIdWithList(aircraftIds: number[]): number {
  if (aircraftIds.length === 0) {
    setCurrentAircraftId(0);
    return 0;
  }
  if (!aircraftIds.includes(currentAircraftId)) {
    setCurrentAircraftId(aircraftIds[0]);
  }
  return currentAircraftId;
}

export const onAircraftChange = (handler: (id: number) => void) => {
  const listener = (event: Event) => {
    const detail = (event as CustomEvent<{ aircraftId: number }>).detail;
    handler(detail?.aircraftId ?? currentAircraftId);
  };
  window.addEventListener(CHANGE_EVENT, listener);
  return () => window.removeEventListener(CHANGE_EVENT, listener);
};
